var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
        'button',
        {
            small: _vm.small,
            large: _vm.large,
            primary: _vm.primary,
            newPrimary: _vm.newPrimary,
            caution: _vm.caution,
            secondary: _vm.secondary,
            newSecondary: _vm.newSecondary,
            grey: _vm.grey,
            red: _vm.red,
            green: _vm.green,
            white: _vm.white,
            transparent: _vm.transparent,
            muted: _vm.muted,
            disabled: _vm.disabled,
            full: _vm.full,
            centred: _vm.centred,
            bordered: _vm.bordered,
            outline: _vm.outline,
            round: _vm.round,
        },
    ],attrs:{"disabled":_vm.disabled,"type":_vm.type,"data-id":_vm.dataIdAttribute},on:{"click":_vm.handleClick}},[_c('span',{class:[{ executing: _vm.getShowSpinner }, 'btn-content-container']},[_c('span',[_vm._t("default")],2),(_vm.icon === 'plus')?_c('img',{attrs:{"src":require("@/assets/img/Icons/Grey/Plus.svg")}}):_vm._e(),(_vm.icon === 'chevron-down')?_c('img',{attrs:{"src":require("@/assets/img/Icons/Grey/Chevron Down.svg")}}):_vm._e()]),(_vm.getShowSpinner)?_c('Spinner',{staticClass:"executing-spinner",attrs:{"size":"small","line-bg-color":"transparent","line-fg-color":"#fff"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }